import React, { PureComponent } from 'react';
import { Modal, Form, Input, Button, Table, Pagination, Select, message } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../../../services/error-handle';
const api = services.api;

interface Product {
    spuId: string;
    spu: string;
    name: string;
    brand: string;
}

interface ProductSelectModalProps {
    visible: boolean;
    onCancel: () => void;
    onOk: (selectedProducts: Product[]) => void;
    type?: 'Single' | 'Multi';
    default: any;
}

interface ProductSelectModalState {
    loading: boolean;
    products: Product[];
    selectedRowKeys: any[];
    selectedProducts: Product[];
    allSelectedProducts: Product[]; // 存储所有已选择的商品
    pageNum: number;
    pageSize: number;
    total: number;
    searchForm: {
        specialTag?: string;
        spu?: string;
        name?: string;
    };
}

export class ProductSelectModal extends PureComponent<
    ProductSelectModalProps,
    ProductSelectModalState
> {
    constructor(props: ProductSelectModalProps) {
        super(props);
        this.state = {
            loading: false,
            products: [],
            selectedRowKeys: [],
            selectedProducts: [],
            allSelectedProducts: [],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            searchForm: {
                specialTag: '',
                spu: '',
                name: '',
            },
        };
    }

    componentDidMount() {
        this.loadProducts();
    }

    componentDidUpdate(prevProps: ProductSelectModalProps) {
        if (this.props.visible && !prevProps.visible) {
            this.resetState();
            setTimeout(() => {
                this.loadProducts();
            }, 100);
        }
    }

    resetState = () => {
        const keys = this.props.default.map((item: Product) => item.spuId);
        console.log(keys, 'keys');
        this.setState({
            selectedRowKeys: keys,
            selectedProducts: this.props.default,
            allSelectedProducts: this.props.default,
            pageNum: 1,
            pageSize: 10,
            total: 0,
            products: [],
            searchForm: {
                specialTag: '',
                spu: '',
                name: '',
            },
        });
    };

    // 加载商品数据
    loadProducts = () => {
        this.setState({ loading: true });
        const { pageNum, pageSize, searchForm } = this.state;

        const params = {
            page: pageNum,
            per_page: pageSize,
            ...searchForm,
        };

        // 过滤空值
        const filterUndefined = (obj: any) => {
            const newObj: any = {};
            Object.keys(obj).forEach((key) => {
                if (obj[key] !== undefined && obj[key] !== '') {
                    newObj[key] = obj[key];
                }
            });
            return newObj;
        };

        const filteredParams = filterUndefined(params);

        api.get(filteredParams, { apiPath: `/products/search/find_spu` })
            .then((res: any) => {
                const { result, totalNum } = res;
                const products = result || [];

                // 更新当前页选中状态
                const currentPageSelectedKeys = products
                    .filter((product: Product) =>
                        this.state.allSelectedProducts.some(
                            (selected) => selected.spuId === product.spuId
                        )
                    )
                    .map((product: Product) => product.spuId);

                this.setState({
                    products,
                    total: totalNum || 0,
                    selectedRowKeys: currentPageSelectedKeys,
                    loading: false,
                });
            })
            .catch((error: any) => {
                errorHandle(error);
                this.setState({ loading: false });
            });
    };

    handleSearch = () => {
        this.setState(
            {
                pageNum: 1,
            },
            () => {
                this.loadProducts();
            }
        );
    };

    handleReset = () => {
        this.setState(
            {
                searchForm: {
                    specialTag: '',
                    spu: '',
                    name: '',
                },
            },
            () => {
                this.handleSearch();
            }
        );
    };

    // 改变分页
    handlePageChange = (current: number, size: number) => {
        this.setState(
            {
                pageNum: current,
                pageSize: size,
            },
            () => {
                this.loadProducts();
            }
        );
    };

    // 改变每页显示数量
    onShowSizeChange = (_current: any, size: any) => {
        this.setState(
            {
                pageNum: 1,
                pageSize: size,
            },
            () => {
                this.loadProducts();
            }
        );
    };

    handleRowSelectionChange = (selectedRowKeys: any[], selectedRows: Product[]) => {
        const { allSelectedProducts } = this.state;

        // 获取当前页未选中的商品ID
        const currentPageUnselectedKeys = this.state.products
            .filter((product) => !selectedRowKeys.includes(product.spuId))
            .map((product) => product.spuId);

        // 从全部选中列表中移除当前页未选中的商品
        const updatedAllSelected = allSelectedProducts.filter(
            (product) => !currentPageUnselectedKeys.includes(product.spuId)
        );

        // 添加当前页新选中的商品
        const newSelectedProducts = selectedRows.filter(
            (product) => !allSelectedProducts.some((selected) => selected.spuId === product.spuId)
        );

        const finalSelectedProducts = [...updatedAllSelected, ...newSelectedProducts];

        this.setState({
            selectedRowKeys,
            selectedProducts: selectedRows,
            allSelectedProducts: finalSelectedProducts,
        });
    };

    handleOk = () => {
        const { allSelectedProducts } = this.state;
        const { onOk } = this.props;

        if (allSelectedProducts.length === 0) {
            message.warning('请至少选择一个商品');
            return;
        }

        onOk(allSelectedProducts);
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    render() {
        const { visible, type = 'Multi' } = this.props;
        const {
            loading,
            products,
            selectedRowKeys,
            pageNum,
            pageSize,
            total,
            allSelectedProducts,
        } = this.state;

        const columns = [
            {
                title: '',
                dataIndex: 'spuId',
                key: 'spuId',
                width: 50,
                render: () => null,
            },
            {
                title: 'SPU',
                dataIndex: 'spu',
                key: 'spu',
                width: 360,
            },
            {
                title: '商品名称',
                dataIndex: 'name',
                key: 'name',
                ellipsis: true,
            },
        ];

        const rowSelection = {
            type: (type === 'Single' ? 'radio' : 'checkbox') as 'radio' | 'checkbox',
            selectedRowKeys,
            onChange: this.handleRowSelectionChange,
        };

        return (
            <Modal
                title="请选择商品"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                width={860}
                okText="确定"
                cancelText="取消"
                destroyOnClose
            >
                <div style={{ marginBottom: 16 }}>
                    <Form layout="inline">
                        <Form.Item label="SPU:">
                            <Input
                                placeholder="请输入"
                                style={{ width: 250 }}
                                value={this.state.searchForm.spu}
                                onChange={(e) =>
                                    this.setState({
                                        searchForm: {
                                            ...this.state.searchForm,
                                            spu: e.target.value,
                                        },
                                    })
                                }
                            />
                        </Form.Item>
                        <Form.Item label="商品名称:">
                            <Input
                                placeholder="请输入"
                                style={{ width: 250 }}
                                value={this.state.searchForm.name}
                                onChange={(e) =>
                                    this.setState({
                                        searchForm: {
                                            ...this.state.searchForm,
                                            name: e.target.value,
                                        },
                                    })
                                }
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button onClick={this.handleReset}>重置</Button>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" onClick={this.handleSearch}>
                                查询
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
                {/* {allSelectedProducts.length > 0 && (
                    <div
                        style={{
                            marginTop: 16,
                            padding: 8,
                            background: '#f5f5f5',
                            borderRadius: 4,
                        }}
                    >
                        <span style={{ color: '#1890ff' }}>
                            已选择 {allSelectedProducts.length} 个商品
                        </span>
                    </div>
                )} */}
                <Table
                    columns={columns}
                    dataSource={products}
                    rowKey="spuId"
                    loading={loading}
                    pagination={false}
                    rowSelection={rowSelection}
                    scroll={{ y: 450 }}
                />

                {products?.length ? (
                    <div style={{ marginTop: 16, textAlign: 'right' }}>
                        <Pagination
                            current={pageNum}
                            pageSize={pageSize}
                            total={total}
                            showSizeChanger={false}
                            showQuickJumper={false}
                            pageSizeOptions={['10', '15', '20']}
                            onShowSizeChange={this.onShowSizeChange}
                            onChange={this.handlePageChange}
                        />
                    </div>
                ) : null}
            </Modal>
        );
    }
}
